import { c as _c } from "react/compiler-runtime";
import type { ReadonlyURLSearchParams } from "next/navigation";
import type React from "react";
import { useCallback, useMemo } from "react";
import { getActiveWaveIdFromUrl, getWaveRoute } from "@/helpers/navigation.helpers";
interface UseWaveNavigationOptions {
  readonly basePath: string;
  readonly activeWaveId: string | null;
  readonly setActiveWave: (waveId: string | null, options?: {
    isDirectMessage?: boolean | undefined;
    serialNo?: number | null | undefined;
    divider?: number | null | undefined;
  }) => void;
  readonly onHover: (waveId: string) => void;
  readonly prefetchWaveData: (waveId: string) => void;
  readonly pathname: string | null;
  readonly searchParams: ReadonlyURLSearchParams | null;
  readonly waveId: string;
  readonly hasTouchScreen: boolean;
  readonly firstUnreadDropSerialNo?: number | null | undefined;
}
interface UseWaveNavigationResult {
  readonly href: string;
  readonly isActive: boolean;
  readonly onMouseEnter: (() => void) | undefined;
  readonly onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}
export const useWaveNavigation = t0 => {
  const $ = _c(25);
  const {
    basePath,
    activeWaveId,
    setActiveWave,
    onHover,
    prefetchWaveData,
    pathname,
    searchParams,
    waveId,
    hasTouchScreen,
    firstUnreadDropSerialNo
  } = t0;
  let t1;
  if ($[0] !== activeWaveId || $[1] !== pathname || $[2] !== searchParams) {
    t1 = activeWaveId ?? getActiveWaveIdFromUrl({
      pathname,
      searchParams
    }) ?? undefined;
    $[0] = activeWaveId;
    $[1] = pathname;
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const currentWaveId = t1;
  const isDirectMessage = basePath === "/messages";
  let t2;
  bb0: {
    if (currentWaveId === waveId) {
      t2 = basePath;
      break bb0;
    }
    let t3;
    if ($[4] !== firstUnreadDropSerialNo || $[5] !== isDirectMessage || $[6] !== waveId) {
      t3 = getWaveRoute({
        waveId,
        extraParams: typeof firstUnreadDropSerialNo === "number" ? {
          divider: String(firstUnreadDropSerialNo)
        } : undefined,
        isDirectMessage,
        isApp: false
      });
      $[4] = firstUnreadDropSerialNo;
      $[5] = isDirectMessage;
      $[6] = waveId;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = t3;
  }
  const href = t2;
  const isActive = waveId === currentWaveId;
  let t3;
  if ($[8] !== currentWaveId || $[9] !== onHover || $[10] !== prefetchWaveData || $[11] !== waveId) {
    t3 = () => {
      if (waveId === currentWaveId) {
        return;
      }
      onHover(waveId);
      prefetchWaveData(waveId);
    };
    $[8] = currentWaveId;
    $[9] = onHover;
    $[10] = prefetchWaveData;
    $[11] = waveId;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const onMouseEnter = t3;
  let t4;
  if ($[13] !== currentWaveId || $[14] !== firstUnreadDropSerialNo || $[15] !== isDirectMessage || $[16] !== onMouseEnter || $[17] !== setActiveWave || $[18] !== waveId) {
    t4 = event => {
      if (event.defaultPrevented) {
        return;
      }
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1 || event.button === 2) {
        return;
      }
      event.preventDefault();
      onMouseEnter();
      const nextWaveId = waveId === currentWaveId ? null : waveId;
      setActiveWave(nextWaveId, {
        isDirectMessage,
        divider: nextWaveId ? firstUnreadDropSerialNo : null
      });
    };
    $[13] = currentWaveId;
    $[14] = firstUnreadDropSerialNo;
    $[15] = isDirectMessage;
    $[16] = onMouseEnter;
    $[17] = setActiveWave;
    $[18] = waveId;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  const onClick = t4;
  const t5 = hasTouchScreen ? undefined : onMouseEnter;
  let t6;
  if ($[20] !== href || $[21] !== isActive || $[22] !== onClick || $[23] !== t5) {
    t6 = {
      href,
      isActive,
      onMouseEnter: t5,
      onClick
    };
    $[20] = href;
    $[21] = isActive;
    $[22] = onClick;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};